import { styled, Stack } from '@mui/material'
import { StackProps } from '@mui/material'

interface AlertContainerProps extends Omit<StackProps, 'variant'> {
  variant?: 'map' | 'default' | 'compact' | 'panel'
}

export const AlertContainer = styled(Stack)<AlertContainerProps>(({ theme, variant }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(10),
  width: '100%',
  ...(
    variant === 'map'
      ? {
        border: '1px solid #D7DAEA',
        borderTopRightRadius: '24px',
        borderBottomRightRadius: '24px',
      }
      : variant === 'compact'
      ? {
        border: '1px dashed #D7DAEA',
        borderRadius: '24px',
      }
      : variant === 'panel'
      ? {
        border: '1px solid #D7DAEA',
        borderRadius: '24px',
      }
      : {
        border: '1px dashed #D7DAEA',
        borderRadius: '24px',
      }
  )
}))

export const AlertText = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  color: '#656565',
  fontFamily: 'Poppins',
  fontSize: '14px',
  textAlign: 'center'
}))

export const AlertIcons = styled('div')(({ theme }) => ({
  display: 'flex',
  color: theme.palette.grey[200],
  gap: theme.spacing(10),
  alignItems: 'center',
}))
